export default function StatusGreenTag({ text }: { text: string }) {
  return (
    <div className="rounded-full w-fit text-xs px-2 py-1 bg-green-500/20 text-green-400 border border-green-700">
      {text}
    </div>
  );
}
